// src/components/shared/Spinner.tsx
// All comments in English only

import { Loader2 } from "lucide-react"; // shadcn + lucide-react icon set
import React from "react";

/**
 * Simple shared spinner component used across pages.
 * You can wrap it inside a container with padding if needed.
 */
export const Spinner: React.FC<{ label?: string }> = ({ label }) => {
  return (
    <div className="flex flex-col items-center justify-center py-10 text-muted-foreground">
      <Loader2 className="h-8 w-8 animate-spin mb-2" />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
};

export default Spinner;
